import React from 'react';
import ReactDOM from 'react-dom';
import Event from '../Event.js';
import ErrorBoundary from '../../ErrorBoundary.js';

class OptionsModalTrigger extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick(event) {
        event.preventDefault();
        Event.fire('optionsModal.show', this.props);
        /* window.location.hash = this.props.hash; */
    }

    componentDidMount() {
        if (this.props.showOnLoad) {
            Event.fire('optionsModal.show', this.props);
        }
    }

    render() {
        return <a href={this.props.linkHref ? this.props.linkHref : '#'} onClick={(event) => this.handleClick(event)} className={this.props.classes}>{this.props.triggerTitle ? this.props.triggerTitle : this.props.title}</a>;
    }
}

let initialLoad = false;
let OptionsModalTriggerElements = document.getElementsByClassName('OptionsModalTrigger');
if (OptionsModalTriggerElements.length > 0) {
    for (let key in OptionsModalTriggerElements) {
        if (OptionsModalTriggerElements.hasOwnProperty(key) && typeof OptionsModalTriggerElements[key].getAttribute === 'function') {
            let title = OptionsModalTriggerElements[key].getAttribute('data-title');
            let altTitle = OptionsModalTriggerElements[key].getAttribute('data-altTitle');
            let classes = OptionsModalTriggerElements[key].getAttribute('data-classes');
            let hash = OptionsModalTriggerElements[key].getAttribute('data-hash');
            let path = OptionsModalTriggerElements[key].getAttribute('data-path');
            let icon = OptionsModalTriggerElements[key].getAttribute('data-icon');
            let showOnLoad = false;
            let linkHref = OptionsModalTriggerElements[key].getAttribute('data-linkHref');
            let triggerTitle = OptionsModalTriggerElements[key].getAttribute('data-triggerTitle');

            if (window.location.hash === hash && !initialLoad) {
                showOnLoad = true;
                initialLoad = true;
            }

            if (title && path) {
                ReactDOM.render(
                    <ErrorBoundary>
                        <OptionsModalTrigger showOnLoad={showOnLoad} title={title} classes={classes} icon={icon}
                            altTitle={altTitle} path={path} triggerTitle={triggerTitle}
                            hash={hash} linkHref={linkHref}
                        />
                    </ErrorBoundary>, OptionsModalTriggerElements[key]);
            }
        }
    }
}